import dayjs from 'dayjs';

export const compareDates = (d1: string | Date | undefined, d2: string | Date | undefined) => {
  if (d1 && d2) {
    return dayjs(d1).isAfter(dayjs(d2)) ? 1 : -1;
  }

  if (!d1) {
    return -1;
  }
  if (!d2) {
    return 1;
  }

  return 0;
};
